var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#60646c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.3332 8c0 4-.5926 6-5.33336 6-4.74074 0-5.33334-2-5.33334-6s.66667-6 5.33334-6c4.66666 0 5.33336 2 5.33336 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.00016 2.6665s.40305 1.59696-.33333 2.33334-2.33333.33333-2.33333.33333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.3335 10.6665h2.66666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.3335 8.6665h5.3333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.6fcc159972c173f5c5a316f40afc6502.svg";
export { ForwardRef as ReactComponent };